// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2958":"76fcfd88","3845":"e01ba60d","9628":"ffe73276","9826":"3e2b46f7"}[chunkId] + ".chunk.css";
};